import { useLingui } from '@lingui/react/macro'

import LazyImage from '@/components/LazyImage'

export const PayCard: React.FC = () => {
  const { t } = useLingui()

  return (
    <div className='mx-auto mt-8 flex max-w-[1198px] items-center justify-center px-4'>
      <div className='flex flex-col items-start gap-3 lg:flex-row lg:items-center'>
        <p className='text-f-text-tertiary text-sm'>{t`Secure Payment:`}</p>
        <div className='flex flex-wrap items-center gap-4 lg:gap-[26px]'>
          {[
            {
              img: '/_common/pricing/mastercard.png',
              name: 'Mastercard',
              width: 111,
            },
            { img: '/_common/pricing/visa.png', name: 'Visa', width: 42 },
            {
              img: '/_common/pricing/american-express.png',
              name: 'AmericanExpress',
              width: 64,
            },
            {
              img: '/_common/pricing/apple-pay.png',
              name: 'ApplePay',
              width: 36,
            },
            {
              img: '/_common/pricing/union-pay.png',
              name: 'UnionPay',
              width: 39,
            },
            {
              img: '/_common/pricing/click-to-pay.png',
              name: 'ClickToPay',
              width: 33,
            },
          ].map((item, index) => (
            <LazyImage
              width={item.width}
              height={24}
              key={item.name}
              src={item.img}
              alt={item.name}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
